// Los productCard son item de un producto final
import React, { useEffect, useState } from 'react'
import { articlesApi } from '../../../api/articlesApi'
import { ROUTE_IMG_DEFAULT } from '../../../constantes/routes'
import { getUrlFromAStream } from '../../../utils/getUrlByFileStream'
import '../../../assests/styles/catalogue/CatalogueCards.scss'
import { Link } from 'react-router-dom'

const ProductCard = ({ item, pathname }) => {
  const [coverImg, setCoverImg] = useState(ROUTE_IMG_DEFAULT)
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    getFTPUrlConvertToBlob(item)
  }, [])

  const getFTPUrlConvertToBlob = async (item) => {
    try {
      if (!item.id_Articulo) {
        setIsLoading(false)
        return
      }

      const resp = await articlesApi.getArticleCoverImg(item.id_Articulo)
      if (resp.data && resp.data !== '' && resp.data.ruta) {
        const url = await getUrlFromAStream(
          resp.data.ruta,
          'application/imagen',
        )
        setCoverImg(url)
      }
      setIsLoading(false)
    } catch (error) {
      setHasError(true)
      setIsLoading(false)
      console.warn('Error loading product image:', error)
    }
  }

  const handleImageError = () => {
    setCoverImg(ROUTE_IMG_DEFAULT)
    setHasError(true)
  }

  return (
    <Link
      to={{ pathname: pathname, item: item }}
      className={`${isLoading ? 'catalogue-card--loading' : ''} ${
        hasError ? 'catalogue-card--error' : ''
      }`}
    >
      <div className="product-card-v2">

        <div className="product-card-image" style={{
          backgroundImage: `url(${coverImg})`,
        }} />

        <div className="product-card-overlay">
          <div className="product-card-title">
            <span>{item.referencia}&nbsp;</span>
            <span>{item.nombre}</span>
          </div>
        </div>

      </div>
      

      {/* <div className="product-card-overlay" style={{
          backgroundImage: `url(${coverImg})`,
      }}>OVERLAY</div> */}
      
      {/* <div
        className="product-card__container"
        style={{
          backgroundImage: `url(${coverImg})`,
        }}
      >
        <div className='product-card__image'></div>
        <div className='product-card__content'>
          <h3 className='product-card__title'>
            {item.referencia && (
              <span className='product-card__reference'>{item.referencia}</span>
            )}
            {item.nombre}
          </h3>
        </div>
      </div> */}
    </Link>
  )
}

export default ProductCard
